export class Alert {
    msg:string;
    status:number;
    type:string;
    closable:boolean;

    constructor(alert) {
        this.msg = alert.msg;
        this.status = alert.status;
        this.type = alert.type;
        this.closable = alert.closable;
    }
}